import { css } from '@emotion/react'
import { getColorOptions } from 'theme/utils'

export const badge = (color: string) => css`
  box-sizing: border-box;
  width: fit-content;
  height: fit-content;
  padding: 6px 10px;
  gap: 5px;
  border-radius: 38px;
  font-weight: 700;
  background: ${getColorOptions(color).secondary};
  backdrop-filter: blur(7.5px);
  color: ${color};
`
